<template>
  <b-table
    sticky-header
    striped
    hover
    responsive="sm"
    :fields="fields"
    :items="items"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
  ></b-table>
</template>

<script>
export default {
  name: "ScrollableTable",
  props: ["items"],
  data() {
    return {
      sortBy: "kilos_volteados",
      sortDesc: true,
      loading: true,
      ready: false
    };
  },
  computed: {
    fields() {
      const fields = Object.keys(this.items[0]).map((field) => ({ key: field, sortable: true }));
      return fields;
    }
  },
  mounted() {}
};
</script>

<style></style>
